<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14Tyvl8/tc-custom/9781614751861.jpg?1704256319596" alt="This image is the cover for the book Capable of Honor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Capable of Honor
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The sequel to the Pulitzer Prize–winning novel is a political thriller examining the influence of the media on presidential elections.</b></p> It is one of the most fundamental questions facing America today: How justifiably, or irresponsibly, do the volatile and unbiased American media—press, television and radio—attempt to interfere with, and control, the political process and the foreign policy of the nation? In a hotly fought Presidential primary, the news media fractures along ideological lines, supporting and distorting the candidates’ records, manipulating the news rather than covering it. <i>Capable of Honor</i>, the third novel in the grand, bestselling <i>Advise and Consent</i> saga, is a compelling blockbuster that shines a harsh and revealing spotlight on how the media shapes the news, guides public opinion, creates policy—and tries to shape history itself. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allen Drury
      </h2>
      
      <p class="authorDescription body article">Allen Drury is a master of political fiction, #1 New York Times bestseller and Pulitzer Prize winner, best known for the landmark novel ADVISE AND CONSENT. A 1939 graduate of Stanford University, Allen Drury wrote for and became editor of two local California newspapers. While visiting Washington, DC, in 1943 he was hired by the United Press (UPI) and covered the Senate during the latter half of World War II. After the war he wrote for other prominent publications before joining the New York Times' Washington Bureau, where he worked through most of the 1950s. After the success of ADVISE AND CONSENT, he left journalism to write full time. He published twenty novels and five works of non-fiction, many of them best sellers. WordFire Press will be reissuing the majority of his works.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Word Fire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06a7b9b2